import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAutoDraftCount } from "@/hooks/useAutoDraftCount";
import { useOrganization } from "@/hooks/useOrganization";
import { useSubscription } from "@/hooks/useSubscription";

export function AutoOrderBadge() {
  const { t } = useTranslation();
  const { data: org } = useOrganization();
  const { data: subscription } = useSubscription(org?.organizationId);
  const { data: count = 0 } = useAutoDraftCount(
    subscription?.hasProAccess ? org?.organizationId : undefined,
  );

  // Hide badge for starter users (no auto-orders feature)
  if (!subscription?.hasProAccess) {
    return null;
  }

  // Hide badge if count is 0 (don't draw attention)
  if (count === 0) {
    return null;
  }

  return (
    <Link
      to="/zamowienia?filter=draft&source=auto"
      className="relative inline-flex items-center justify-center rounded-full bg-accent px-2.5 py-1 text-xs font-bold text-navy transition-colors hover:bg-accent/80"
      title={t("autoOrderBadge.tooltip", { count })}
      aria-label={t("autoOrderBadge.ariaLabel", { count })}
    >
      {count > 99 ? "99+" : count}
    </Link>
  );
}
